import { Box, Button, TextField } from "@mui/material";
import React, { useState } from "react";
import MagnifierIcon from "../../shared/assets/icons/MagnifierIcon";

export interface AdminSearchProps {
  value?: string;
  onSearch: (value?: string) => void;
  placeholder?: string;
}

const AdminSearch = ({ value, onSearch, placeholder }: AdminSearchProps) => {
  const [tempValue, setTempValue] = useState(value);

  const handleSearchTextChange = (event: any) => {
    setTempValue(event.target.value);
  };

  const onEnterSearch = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      onSearch(tempValue);
    }
  };

  return (
    <Box>
      <TextField
        sx={{ width: "500px", borderRadius: "6px 0 0 6px" }}
        placeholder={placeholder}
        className="border-radius-search"
        value={tempValue}
        onChange={handleSearchTextChange}
        onKeyDown={onEnterSearch}
      />

      <Button
        sx={{ minWidth: "54px", height: "46px", borderRadius: "0 6px 6px 0", padding: "10px 13px" }}
        variant="contained"
        onClick={() => onSearch(tempValue)}
      >
        <MagnifierIcon />
      </Button>
    </Box>
  );
};

export default AdminSearch;